import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

const Root = styled(Text)`
  display: block;
  padding: 24px 4px;
  text-align: center;
  color: ${COLORS.textMuted};
  font-size: 14px;
`;

export type EmptyStateProps = {
  text: string;
};

/** Centred muted message for an empty list/filter result. */
export const EmptyState = ({ text }: EmptyStateProps): React.ReactElement => <Root text={text} tag="span" />;

export default EmptyState;
